<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="ad-sales-breakdown-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Ad Breakdown
                        </h4>
                    </div>

                    <loading-spinner v-if="loading"/>

                    <div v-else class="modal-body">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="col-xs-6">
                                    Company
                                </th>

                                <th class="col-xs-6">
                                    Portal
                                </th>

                                <th class="col-xs-6">
                                    Order
                                </th>

                                <th class="col-xs-6 text-right">
                                    Price
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="row in rows">
                                <td class="table__ellipsis">
                                    <router-link :to="'/companies/' + row.company_id" @click.native="hide">
                                        {{ row.company_name }}
                                    </router-link>
                                </td>

                                <td>
                                    {{ row.portal_name }}
                                </td>

                                <td class="table__ellipsis">
                                    <router-link
                                        :to="'/companies/' + row.company_id + '/orders/' + row.order_id"
                                        @click.native="hide"
                                    >
                                        {{ row.order_title }}
                                    </router-link>
                                </td>

                                <td class="table__ellipsis text-right">
                                    {{ (row.publication_ad_revenue || 0) + (row.time_ad_revenue || 0) | price }}
                                </td>
                            </tr>
                            </tbody>

                            <tfoot>
                            <tr>
                                <td colspan="3" class="text-right">
                                    <b>
                                        Total
                                    </b>
                                </td>

                                <td class="text-right">
                                    <b>
                                        {{ total | price }}
                                    </b>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                        <simple-pager :current-page="page" :last-page="lastPage" @navigate="page = $event"/>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SimplePager from '../../../Lists/SimplePager'

export default {
    components: {SimplePager, ResourcePager, LoadingSpinner},

    props: {
        from: {
            required: true
        },

        to: {
            required: true
        },

        publishedFrom: {
            required: false
        },

        publishedTo: {
            required: false
        },

        users: {
            required: false
        },

        portals: {
            required: false
        },

        channels: {
            required: false
        },

        company: {
            required: false
        },

        filters: {
            required: true
        }
    },

    data() {
        return {
            data: null,

            page: 1,
            loading: true
        }
    },

    mounted() {
        this.listenForClose()
    },

    watch: {
        to() {
            this.load()
        },

        from() {
            this.load()
        },

        publishedFrom() {
            this.load()
        },

        publishedTo() {
            this.load()
        },

        users() {
            this.load()
        },

        portals() {
            this.load()
        },

        channels() {
            this.load()
        },

        company() {
            this.load()
        },

        filters() {
            this.load()
        }
    },

    computed: {
        rows() {
            return this.data.slice((this.page - 1) * 10, this.page * 10)
        },

        lastPage() {
            return Math.ceil(this.data.length / 10)
        },

        total() {
            return Math.round(this.data.reduce((total, row) => parseFloat((row.publication_ad_revenue || 0) + (row.time_ad_revenue || 0)) + total, 0))
        },

        filteredFilters() {
            return this.filters.filter(filter => filter.dimension !== 'sales_date').concat([
                {dimension: 'sales_date', operator: '>=', value: this.from},
                {dimension: 'sales_date', operator: '<=', value: this.to}
            ])
        }
    },

    methods: {
        load() {
            this.loading = true

            http.post('/api/v1/reports/leadout-dashboard', {
                metrics: ['publication_ad_revenue', 'time_ad_revenue'],
                filters: this.filteredFilters,
                dimensions: [
                    'order_title',
                    'order_id',
                    'company_id',
                    'company_name',
                    'portal_id',
                    'portal_name'
                ]
            }).then(response => {
                this.data = response.data.data

                this.loading = false
            })
        },

        hide() {
            $(this.$el).modal('hide')
        },

        listenForClose() {
            $(this.$el).on('hidden.bs.modal', this.reset)
        },

        reset() {
            this.page = 1
        }
    }
}
</script>
